import { FC, useRef } from "react"
import { PackPermission, usePackContext } from ".";
import getConfig from 'next/config';
import URI from 'urijs';
import { MdNotifications } from '@react-icons/all-files/md/MdNotifications';
import { Icon, AlertDialog, AlertDialogHeader, AlertDialogOverlay, AlertDialogContent, AlertDialogBody, AlertDialogFooter, Button,Box, useDisclosure } from "@chakra-ui/react";
import { usePack } from "lib/hooks";
import { isPreviewingPack } from "lib/utils";
import { useRouter } from "next/router";

const { publicRuntimeConfig: { genericSubDomain, baseProtocol, baseDomain, basePort }} = getConfig();

export const LoginPrompt: FC = () => {
  const { packId } = usePackContext();
  const { pathname } = useRouter();
  const { data: pack } = usePack(packId);
  const cancelRef = useRef();
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  if (
    !pack?.upgradable_permission ||
    pack?.upgradable_permission === PackPermission.READ_ONLY ||
    isPreviewingPack(pathname)
  ) {
    return null;
  }

  const goToLogin = () => {
    const { path } = URI.parse(window.location.href);
    window.open(`${baseProtocol}://${genericSubDomain}${baseDomain}${basePort}/login?next=${path}`, '_blank');
  }

  const isAdmin = pack?.upgradable_permission === PackPermission.ADMIN;

  return (
    <AlertDialog motionPreset="slideInBottom" leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen} isCentered>
      <AlertDialogOverlay />
      <AlertDialogContent className="dialog__content">
        <AlertDialogHeader className="dialog-delete__header">
          <Icon as={MdNotifications} boxSize={22} fill="brand.500" />
          <Box>You&apos;re {isAdmin ? 'an admin' : 'a collaborator'} for this Pack</Box>
        </AlertDialogHeader>
        <AlertDialogBody className="dialog-delete__content">
          To unlock {isAdmin ? 'admin' : 'collaborator'} privileges for this pack - like adding or editing assets - sign in now.
        </AlertDialogBody>
        <AlertDialogFooter className="dialog-delete__footer">
          <Button variant="cancel" ref={cancelRef} onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={goToLogin}>Sign into Packs</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
